module.exports = __webpack_public_path__ + "assets/img/ZT2618-M.c1f14d92.png";